import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { RouterState } from "mobx-state-router";

import { withStyles } from "@material-ui/core/styles";

const styles = theme => ({
  nowrap: {
    whiteSpace: "nowrap"
  }
});

@inject("rootStore")
@observer
class FootInfo extends Component {
  //===========================================================================
  //===========================================================================

  render() {
    return (
      <div id="footer">
        <div className="main-container mt20">
          <div className="footer-info">
            <span className="footer-logo">COALRA.COM</span>
            상호 : (주)투키스아이티 &nbsp; 대표 : 박태현 <br />
            주소 : 06307 서울시 강남구 개포4동 1231-23 선만빌딩 401호 <br />
            사업자등록 : 220-87-30720 &nbsp;{" "}
            <span className={this.props.classes.nowrap}>
              통신판매업 : 제2015-서울강남-01209호
            </span>{" "}
            <br />
            copyrightⓒ2019 (주)투키스아이티 All rights reserved.
          </div>
          <div className="footer-info">
            <br />
            <br />
            고객센터 : 02-6408-2208 <br />
            운영시간 : 오전 10시 ~ 오후 5시 (점심: 12시 30분 ~ 1시 30분) <br />
          </div>
        </div>
      </div>
    );
  }
  //===========================================================================
  /**
   * 메뉴 링크 라우트
   */
  goTo = route => {
    const { routerStore } = this.props.rootStore;
    routerStore.goTo(new RouterState(route));
  };
  //===========================================================================
}

export default withStyles(styles)(FootInfo);
